module.exports = __webpack_public_path__ + "static/media/logo_circle.0b5050fd.png";